import { render, staticRenderFns } from "./prop_editor.vue?vue&type=template&id=5f0cb1c0&scoped=true&lang=pug&"
import script from "./prop_editor.vue?vue&type=script&lang=js&"
export * from "./prop_editor.vue?vue&type=script&lang=js&"
import style0 from "./prop_editor.vue?vue&type=style&index=0&id=5f0cb1c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cb1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f0cb1c0', component.options)
    } else {
      api.reload('5f0cb1c0', component.options)
    }
    module.hot.accept("./prop_editor.vue?vue&type=template&id=5f0cb1c0&scoped=true&lang=pug&", function () {
      api.rerender('5f0cb1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop_panel/component/prop_editor.vue"
export default component.exports